export const HEADLINE_MAX_LENGTH = 128;
export const DESCRIPTION_MAX_LENGTH = 128;
export const MAX_VALUE = 999_999.99;
export const MIN_VALUE = 1;

const VALUE_PATTERN = /^\d+(\.\d{1,2})?$/;

export type UpliftValueFieldError = "required" | "tooLong" | "invalidFormat" | "tooLarge" | "minValue";

export interface UpliftValueFields {
    headline: string;
    description: string;
    value: string;
}

export interface UpliftValueErrors {
    headline?: UpliftValueFieldError;
    description?: UpliftValueFieldError;
    value?: UpliftValueFieldError;
}

const validateText = (text: string, maxLength: number, isRequired: boolean): UpliftValueFieldError | undefined => {
    const trimmed = text.trim();
    if (trimmed === "") {
        return isRequired ? "required" : undefined;
    }
    return trimmed.length > maxLength ? "tooLong" : undefined;
};

const validateValue = (value: string): UpliftValueFieldError | undefined => {
    const trimmed = value.trim();
    if (trimmed === "") {
        return "required";
    }
    if (!VALUE_PATTERN.test(trimmed)) {
        return "invalidFormat";
    }
    if (Number(trimmed) > MAX_VALUE ? "tooLarge" : undefined) {
        return "tooLarge";
    }
    return Number(trimmed) < MIN_VALUE ? "minValue" : undefined;
};

export const validateUpliftValue = (fields: UpliftValueFields): UpliftValueErrors => ({
    headline: validateText(fields.headline, HEADLINE_MAX_LENGTH, true),
    description: validateText(fields.description, DESCRIPTION_MAX_LENGTH, false),
    value: validateValue(fields.value),
});

export const isUpliftValueValid = (fields: UpliftValueFields) =>
    Object.values(validateUpliftValue(fields)).every((error) => error === undefined);
